import { render } from "./form-password.vue?vue&type=template&id=2813e75c"
import script from "./form-password.js?vue&type=script&lang=js&external"
export * from "./form-password.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__